import { type CSSProperties, memo } from 'react';

import { type WorkspaceAgentSelectAssetVirtualRow } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/select-asset/toWorkspaceAgentSelectAssetVirtualRows';
import { WorkspaceAgentSelectAssetListRow } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/select-asset/WorkspaceAgentSelectAssetListRow';

export type WorkspaceAgentSelectAssetVirtualRowViewProps = {
  getIsBoardItemDisabled?: (boardId: string) => boolean;
  highlightedIndex: number;
  isKeyboardHighlight: boolean;
  onHighlight: (index: number) => void;
  onSelectItem: (itemId: string) => void;
  onToggleExpanded: ((nodeId: string, isExpanded: boolean) => void) | undefined;
  pendingChildCountNodeIds: ReadonlySet<string> | undefined;
  row: WorkspaceAgentSelectAssetVirtualRow;
  style: CSSProperties;
};

export const WorkspaceAgentSelectAssetVirtualRowView = memo(
  ({
    getIsBoardItemDisabled,
    highlightedIndex,
    isKeyboardHighlight,
    onHighlight,
    onSelectItem,
    onToggleExpanded,
    pendingChildCountNodeIds,
    row,
    style,
  }: WorkspaceAgentSelectAssetVirtualRowViewProps) => {
    const content =
      row.kind === 'libraries-heading' ? (
        <div
          aria-hidden
          className="px-1 pb-1 font-bold text-10 text-gray-10 uppercase leading-none"
          data-testid="WORKSPACE_AGENT_MENTION_LIBRARIES_LABEL"
        >
          Libraries
        </div>
      ) : (
        <WorkspaceAgentSelectAssetListRow
          getIsBoardItemDisabled={getIsBoardItemDisabled}
          isKeyboardHighlighted={isKeyboardHighlight && row.itemIndex === highlightedIndex}
          isPendingChildCount={pendingChildCountNodeIds?.has(row.item.id) ?? false}
          isSelected={row.itemIndex === highlightedIndex}
          item={row.item}
          itemIndex={row.itemIndex}
          onHighlight={onHighlight}
          onSelectItem={onSelectItem}
          onToggleExpanded={onToggleExpanded}
        />
      );

    return (
      <div className="absolute top-0 left-0 w-full" style={style}>
        {content}
      </div>
    );
  },
);

WorkspaceAgentSelectAssetVirtualRowView.displayName = 'WorkspaceAgentSelectAssetVirtualRowView';
